// removed by extract-text-webpack-plugin
module.exports = {"tiles":"home__tiles--3foXF","mainWrapper":"home__mainWrapper--3HRVc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/screens/Home/home.css
// module id = PzCm
// module chunks = 0